import { useEffect } from 'react';
import { usePrevious } from 'hooks/usePrevious';
import { noop } from 'utils/common';

let events = ['mousedown', 'touchstart'];

let supportsPassiveEvents;

function canUsePassiveEvents() {
  if (supportsPassiveEvents !== undefined) {
    return supportsPassiveEvents;
  }

  let passive = false;
  let options = {
    // eslint-disable-next-line getter-return
    get passive() {
      passive = true;
    }
  };

  window.addEventListener('test', noop, options);
  window.removeEventListener('test', noop, options);
  supportsPassiveEvents = passive;
  return passive;
}

function getOptions(event) {
  if (event !== 'touchstart') {
    return;
  }

  if (canUsePassiveEvents()) {
    return { passive: true };
  }
}

export function useOnClickOutside(ref, handler, options) {
  let { allowClickOnPortal, allowClickOnTooltip, allowClickOn, triggerRef } =
    options;
  let handlerRef = usePrevious(handler);

  useEffect(() => {
    if (!handler) {
      return;
    }

    function listener(event) {
      if (
        !handlerRef ||
        ref.current?.contains(event.target) ||
        triggerRef.current?.contains(event.target) || // if provided delegate to handle it by component
        (allowClickOnPortal &&
          document.querySelector('portal')?.contains(event.target)) ||
        (allowClickOnTooltip &&
          document.querySelector('#with-tooltip')?.contains(event.target)) ||
        (allowClickOn &&
          allowClickOn.some(selector =>
            Array.from(document.querySelectorAll(selector)).some(node =>
              node?.contains(event.target)
            )
          ))
      ) {
        return;
      }
      handlerRef(event);
    }

    events.forEach(event => {
      document.addEventListener(event, listener, getOptions(event));
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, listener, getOptions(event));
      });
    };
  }, [
    handler,
    handlerRef,
    ref,
    triggerRef,
    allowClickOnPortal,
    allowClickOnTooltip,
    allowClickOn
  ]);
}
